export default __webpack_public_path__ + "static/media/icon-red-cross.9a30588f.svg";